<template>
  <v-container>
    <v-row
      style="display: flex; flex-direction: column"
      @keydown.esc="cancel()"
    >
      <Header :key="counter" :updatedItems="updatedItems" :items="items"
        ><template slot="title">
          {{ $tc("changeTimePattern.title") }}
        </template></Header
      >
      <v-col class="mt-n5">
        <ChangeTables
          :headers1="headers"
          :title1="title"
          :items1="getTimePattern"
          :seeTables="false"
        />
      </v-col>
      <v-col class="mt-n5">
        <CardDialog class="card-dialog">
          <template slot="title">
            <h4 style="color: #39537a; font-weight: lighter !important">
              {{ $tc("changeGroup.completeForm") }}
            </h4>
          </template>
          <template slot="body">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              style="margin: 10px"
              :disabled="signed"
            >
              <div style="max-width: 550px !important" class="mx-auto">
                <v-alert
                  dense
                  v-if="error"
                  color="red"
                  elevation="5"
                  outlined
                  text
                  type="error"
                  align="center"
                  class="mr-1 ml-1"
                >
                  {{ alertValidate }}</v-alert
                >

                <date class="ml-0 mt-5 mb-5" />

                <v-select
                  dense
                  multiple
                  v-model="data.pattern"
                  required
                  :rules="rules"
                  :items="pattern"
                  item-value="id"
                  item-text="name"
                  attach
                  chips
                  outlined
                  class="pattern mb-n6"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index <= 3">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 4" class="grey--text text-caption">
                      (+ {{ data.pattern.length - 4 }} )
                    </span>
                  </template>
                </v-select>
                <div
                  style="
                    border: 1px solid #959595;
                    border-radius: 5px;
                    height: 40px;
                  "
                >
                  <v-slider
                    v-model="data.tolerance"
                    max="100"
                    thumb-label="always"
                    :label="$tc('changeTimePattern.tolerance')"
                    class="ml-2 slider"
                    thumb-size="20"
                  />
                </div>
                <v-select
                  dense
                  required
                  :rules="rules"
                  v-model="costs"
                  :items="getCost"
                  item-value="id"
                  item-text="name"
                  :label="$tc('changeTimePattern.cost')"
                  outlined
                  class="mt-5 mb-n4"
                  style="height: 75px"
                />
                <v-select
                  dense
                  required
                  :rules="rules"
                  v-model="data.autoriz"
                  :label="$tc('changeTimePattern.autoriz')"
                  outlined
                  :items="autoriz"
                  item-value="value"
                  item-text="name"
                  class="mb-n4"
                />
              </div>
            </v-form>
            <div class="d-flex justify-space-between mx-2 mb-n4">
              <v-btn class="bt-exit" @click="cancel()" :disabled="signed"
                >{{ $tc("editRegistrations.cancel") }}
              </v-btn>
              <v-btn
                class="bt-acept"
                @click.prevent="validate"
                :disabled="signed"
              >
                {{ $tc("editRegistrations.acept") }}</v-btn
              >
            </div>
          </template>
        </CardDialog>
      </v-col>
    </v-row>
    <v-snackbar v-model="alertOk" color="#909DFA" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="alertOk = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="alertError" color="#FF8D58" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="alertError = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import ChangeTables from "./common/ChangeTables.vue";
import Header from "./common/Header.vue";
import CardDialog from "./common/CardDialog.vue";
import registrations from "../../../store/gestionTiempos/registrations";
import changeTimePattern from "../../../store/gestionTiempos/changeTimePattern";
import Date from "./common/DateRegis.vue";

export default {
  components: { Header, CardDialog, ChangeTables, Date },
  props: {
    items: Object,
    refreshForm: Number,
  },
  data() {
    return {
      counter: 0,
      valid: true,
      title: this.$tc("changeTimePattern.timePattern"),
      updatedItems: [],
      headers: [
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
        {
          text: "Liq.Horas",
          value: "liqhs",
          class: "primary secondary--text",
          align: "center",
          width: 80,
        },
        {
          text: "Liq.Parcial",
          value: "licPar",
          class: "primary secondary--text",
          align: "center",
          width: 80,
        },
        {
          text: "Liq.Total",
          value: "licTot",
          class: "primary secondary--text",
          align: "center",
          width: 80,
        },

        {
          text: "Ret. anticipado",
          value: "retAnt",
          class: "primary secondary--text",
          align: "center",
        },
        {
          text: "Tarde",
          value: "late",
          class: "primary secondary--text",
          align: "center",
          width: 80,
        },
        {
          text: "Caídas",
          value: "falls",
          class: "primary secondary--text",
          align: "center",
          width: 80,
        },
        {
          text: "Hs. caidas totales",
          value: "hCaiTol",
          class: "primary secondary--text",
          align: "center",
        },
        {
          text: "Autorizar liq.",
          value: "autorizLiq",
          class: "primary secondary--text",
          align: "center",
        },
      ],
      alertValidate: "",
      error: false,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      alertError: false,
      alertOk: false,
      textAlert: "",
      fromMenuDate: false,
      toMenuDate: false,
      data: {
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        pattern: [0, 1, 2, 3, 4, 5],
        tolerance: 0,
        cost: null,
        autoriz: "D",
      },
      checkTo: this.$store.state.gestionTiempos.checkTo,
      pattern: [
        { name: "Liq. Horas", id: 0 },
        { name: "Tarde", id: 1 },
        { name: "Ret.Anticipado", id: 2 },
        { name: "Lic. Parcial", id: 3 },
        { name: "Lic.Total", id: 4 },
        { name: "Caídas", id: 5 },
      ],
      autoriz: [
        { name: "Siempre", value: "T" },
        { name: "Nunca", value: "N" },
        { name: "Predeterminado", value: "D" },
      ],
    };
  },
  watch: {
    refreshForm(newValue, oldValue) {
      if (newValue > oldValue) {
        this.data = {
          from: this.$store.state.gestionTiempos.dateFromComponents,
          to: this.$store.state.gestionTiempos.dateToComponents,
          date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
          pattern: [
            { name: "Liq. Horas", value: true, id: 0 },
            { name: "Tarde", value: true, id: 1 },
            { name: "Ret.Anticipado", value: true, id: 2 },
            { name: "Lic. Parcial", value: true, id: 3 },
            { name: "Lic.Total", value: true, id: 4 },
            { name: "Caídas", value: true, id: 5 },
          ],
          tolerance: 0,
          cost: this.cost,
          autoriz: "D",
        };
        this.checkTo = false;
      }
    },
  },
  computed: {
    signed() {
      return this.$store.state.gestionTiempos.signed;
    },
    getCost() {
      return registrations.state.csCosts;
    },
    getTimePattern() {
      return changeTimePattern.state.timePattern.item;
    },
    costs: {
      get() {
        const cost = registrations.state?.csCosts.find((e) => e.id == 1);
        this.data.cost = cost?.id;
        return this.data.cost;
      },
      set(val) {
        //
      },
    },
  },
  methods: {
    //se valida el formulario
    validate() {
      if (this.$store.state.gestionTiempos.checkTo) {
        this.$store.commit("gestionTiempos/setDateToComponents", null);
        this.data.to = null;
      }
      let valid = this.$refs.form.validate();
      if (valid) {
        if (this.data.from > this.data.to) {
          this.error = true;
          this.alertValidate = this.$tc("autoriz.greater");
          setTimeout(() => {
            this.error = false;
          }, 2500);
        } else {
          this.addChangeTimePattern();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    //se agrega
    addChangeTimePattern() {
      const selectedValues = this.data.pattern;
      let result = [];

      this.pattern.forEach((element) => {
        let selected = false;

        for (let i = 0; i < selectedValues.length; i++) {
          if (
            element.id === selectedValues[i] ||
            element.id === selectedValues[i]?.id
          ) {
            selected = true;
          }
        }

        result.push({
          name: element.name,
          id: element.id,
          selected: selected ? "S" : "N",
        });
      });

      let payload = {
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        tolerance: this.data.tolerance,
        cost: this.data.cost,
        autoriz: this.data.autoriz,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        pattern: this.data.pattern,
      };
      for (let i = 0; i < result.length; i++) {
        switch (result[i].id) {
          case 0:
            payload["liqHoras"] = result[i].selected;
            break;
          case 1:
            payload["tarde"] = result[i].selected;
            break;
          case 2:
            payload["retAnt"] = result[i].selected;
            break;
          case 3:
            payload["licPar"] = result[i].selected;
            break;
          case 4:
            payload["licTot"] = result[i].selected;
            break;
          case 5:
            payload["caidas"] = result[i].selected;
            break;
          default:
            break;
        }
      }

      changeTimePattern.commit("setNew", payload);
      changeTimePattern
        .dispatch("newTimePattern")
        .then((r) => {
          this.textAlert = this.$tc("changeTimePattern.alertOk");
          this.alertOk = true;
          this.counter++;
          changeTimePattern.dispatch("getTimePattern");
          setTimeout(() => {
            this.$emit("close");
          }, 2500);
        })
        .catch((e) => {
          this.alertError = true;
          this.textAlert = this.$tc("changeTimePattern.alertError");
        });
      this.reset();
    },

    //se cancela el formulario
    cancel() {
      this.error = false;
      this.$emit("close");
      this.reset();
    },
    //se resete el formulario
    reset() {
      this.$refs.form.resetValidation();
      this.checkTo = false;
      const cost = registrations.state?.csCosts.find((e) => e.id == 1);
      const today = this.items.date
        .slice(0, 10)
        .split(/\D/)
        .reverse()
        .join("-");
      this.$store.commit("gestionTiempos/setDateFromComponents", today);
      this.$store.commit("gestionTiempos/setDateToComponents", today);
      this.$store.commit("gestionTiempos/setCheckTo", this.checkTo);
      this.data = {
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        pattern: [
          { name: "Liq. Horas", value: true, id: 0 },
          { name: "Tarde", value: true, id: 1 },
          { name: "Ret.Anticipado", value: true, id: 2 },
          { name: "Lic. Parcial", value: true, id: 3 },
          { name: "Lic.Total", value: true, id: 4 },
          { name: "Caídas", value: true, id: 5 },
        ],
        tolerance: 0,
        cost: cost.id,
        autoriz: "D",
      };
      this.pattern = [
        { name: "Liq. Horas", id: 0, value: true },
        { name: "Tarde", id: 1, value: true },
        { name: "Ret.Anticipado", id: 2, value: true },
        { name: "Lic. Parcial", id: 3, value: true },
        { name: "Lic.Total", id: 4, value: true },
        { name: "Caídas", id: 5, value: true },
      ];
    },
  },
};
</script>

<style scoped>
.card-dialog {
  display: flex !important;
  justify-content: center !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.pattern {
  height: 88px !important;
}

@media (min-width: 300px) and (max-width: 450px) {
  .card-dialog {
    display: flex !important;
    justify-content: center !important;
    width: 355px !important;
  }

  .pattern {
    height: 120px !important;
    margin-bottom: 19px !important;
  }

  .slider {
    display: flex !important;
    flex-direction: column !important;
    width: 100px !important;
  }
}
</style>
